module.exports = __webpack_public_path__ + "static/img/goemas.ced5b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goemas.png
// module id = Fkgb
// module chunks = 1